// GroundOverlayLayer — Frontend-Anzeige flacher Bild-Overlays (ohne Tiles) als google.maps.GroundOverlay.
//
// Gegenstück zum getilten Pfad (ImageMapType in basic.js/overlayControls2). Ein Overlay mit display_mode 'flat'
// (kein Tile-Ordner vorhanden) wird hier als ein einzelnes, in seine SW/NE-Bounds projiziertes Bild gezeigt.
// Verwaltung pro Karte: GroundOverlay-Instanzen nach Overlay-Id, mit Abgleich (retain) gegen die sichtbaren Ids,
// damit arrangeOverlays nicht bei jedem Lauf alles neu baut (kein Flackern).
//
// GroundOverlay-Bounds sind unveränderlich → bei Bounds-Wechsel neu anlegen (im Frontend ändern sie sich nicht zur
// Laufzeit). Opacity ist 0..1.
//
// google wird zur Laufzeit injiziert (kein OverlayView, aber dieselbe Konvention wie im restlichen topoMapCore-Kern).

export function createGroundOverlayLayerClass(google) {
    return class GroundOverlayLayer {
        constructor(map) {
            this._map = map;
            this._items = new Map();   // String(id) -> google.maps.GroundOverlay
        }

        // Legt das Overlay an (oder aktualisiert nur die Opacity, falls schon vorhanden) und hängt es an die Karte.
        ensure(id, { url, bounds, opacity = 1 }) {
            const key = String(id);
            let go = this._items.get(key);
            if (!go) {
                go = new google.maps.GroundOverlay(url, bounds, { opacity, clickable: false });
                go.setMap(this._map);
                this._items.set(key, go);
            } else {
                go.setOpacity(opacity);
            }
            return go;
        }

        setOpacity(id, opacity) {
            const go = this._items.get(String(id));
            if (go) { go.setOpacity(opacity); }
        }

        remove(id) {
            const key = String(id);
            const go = this._items.get(key);
            if (go) {
                go.setMap(null);
                this._items.delete(key);
            }
        }

        // Behält nur die Overlays mit den übergebenen Ids; entfernt alle anderen (Abgleich nach Sichtbarkeit).
        retain(ids) {
            const keep = new Set((ids || []).map(String));
            for (const key of [...this._items.keys()]) {
                if (!keep.has(key)) { this.remove(key); }
            }
        }

        clear() {
            this.retain([]);
        }
    };
}
